module.exports = __webpack_public_path__ + "static/media/404.56e94ac6.png";